import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import { GROUP_NAME, GROUP_URL } from './App';
import { apiv1 } from './api/apiv1';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {'Copyright © '}
      <Link color="text.secondary" href={GROUP_URL}>
        {GROUP_NAME}
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const [showBubble, setShowBubble] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const linkRef = React.useRef<HTMLAnchorElement>(null);

  return (
    <React.Fragment>
      <Divider />
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 4, sm: 8 },
          py: { xs: 8, sm: 10 },
          textAlign: { sm: 'center', md: 'left' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              minWidth: { xs: '100%', sm: '60%' },
            }}
          >
            <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ fontWeight: 600, mt: 2 }}
              >
                Join the newsletter
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                Subscribe for updates. Your data will never be sold or shared.
              </Typography>
              <InputLabel htmlFor="email-newsletter">Email</InputLabel>
              <Stack direction="row" spacing={1} useFlexGap>
                <TextField
                  id="email-newsletter"
                  hiddenLabel
                  size="small"
                  variant="outlined"
                  fullWidth
                  aria-label="Enter your email address"
                  slotProps={{
                    htmlInput: {
                      autoComplete: 'off',
                      'aria-label': 'Enter your email address',
                    },
                  }}
                  sx={{ width: '250px' }}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ flexShrink: 0 }}
                  onClick={async () => {
                    const response = await apiv1.subscribeToNewsletter(email);
                    const button = document.activeElement as HTMLElement;
                    const rect = button.getBoundingClientRect();
                    const bubble = document.createElement('div');
                    if (response.success) {
                      setEmail('');
                      bubble.textContent = 'Thank you!';
                      bubble.style.background = '#fff';
                      bubble.style.color = '#333';
                      button.setAttribute('disabled', 'true');
                      const input = document.getElementById('email-newsletter') as HTMLInputElement | null;
                      if (input) {
                        input.disabled = true;
                      }
                    } else {
                      bubble.textContent = 'Something went wrong';
                      bubble.style.background = '#ffebee';
                      bubble.style.color = '#d32f2f';
                    }
                    bubble.style.position = 'fixed';
                    bubble.style.left = `${rect.left + rect.width / 2}px`;
                    bubble.style.top = `${rect.top - 40}px`;
                    bubble.style.transform = 'translate(-50%, 0)';
                    bubble.style.padding = '8px 16px';
                    bubble.style.borderRadius = '8px';
                    bubble.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
                    bubble.style.zIndex = '9999';
                    bubble.style.fontSize = '1rem';
                    document.body.appendChild(bubble);
                    setTimeout(() => {
                      bubble.remove();
                    }, 2000);
                  }}
                >
                  Subscribe
                </Button>
              </Stack>
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Sitemap
            </Typography>
            <Link component={RouterLink} to="/" color="text.secondary" variant="body2">
              Home
            </Link>
            <Link component={RouterLink} to="/legislation" color="text.secondary" variant="body2">
              Legislation
            </Link>
            <Link component={RouterLink} to="/about" color="text.secondary" variant="body2">
              About
            </Link>
            <Link component={RouterLink} to="/contact" color="text.secondary" variant="body2">
              Contact
            </Link>
            <Link component={RouterLink} to="/blog" color="text.secondary" variant="body2">
              Blog
            </Link>
          </Box>
          {/* <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Company
            </Typography>
            <Link color="text.secondary" variant="body2" href="#">
              About us
            </Link>
            <Link color="text.secondary" variant="body2" href="#">
              Careers
            </Link>
            <Link color="text.secondary" variant="body2" href="#">
              Press
            </Link>
          </Box> */}
          {/* <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Legal
            </Typography>
            <Link color="text.secondary" variant="body2" href="#">
              Terms
            </Link>
            <Link color="text.secondary" variant="body2" href="#">
              Privacy
            </Link>
            <Link color="text.secondary" variant="body2" href="#">
              Contact
            </Link>
          </Box> */}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            pt: { xs: 4, sm: 8 },
            width: '100%',
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <div>
            <Box sx={{ display: 'inline-block', position: 'relative' }}>
              <Link
              ref={linkRef}
              color="text.secondary"
              variant="body2"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowBubble(true);
              }}
              title="Coming soon"
              sx={{ cursor: 'pointer' }}
              onMouseEnter={() => setShowBubble(true)}
              onMouseLeave={() => setShowBubble(false)}
              >
              Privacy Policy
              </Link>
              {showBubble && (
              <Box
                sx={{
                position: 'absolute',
                bottom: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                bgcolor: 'background.paper',
                color: 'text.primary',
                boxShadow: 6,
                borderRadius: 2,
                px: 3,
                py: 2,
                mb: 1,
                zIndex: 9999,
                fontSize: '0.875rem',
                border: '1px solid',
                borderColor: 'divider',
                minWidth: '120px',
                textAlign: 'center',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 0,
                  height: 0,
                  borderLeft: '8px solid transparent',
                  borderRight: '8px solid transparent',
                  borderTop: '8px solid',
                  borderTopColor: 'divider',
                },
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 0,
                  height: 0,
                  borderLeft: '7px solid transparent',
                  borderRight: '7px solid transparent',
                  borderTop: '7px solid',
                  borderTopColor: 'background.paper',
                  marginTop: '-1px',
                },
                }}
              >
                Coming soon
              </Box>
              )}
            </Box>
            <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
              &nbsp;•&nbsp;
            </Typography>
            <Copyright />
          </div>
          {/* <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{ justifyContent: 'left', color: 'text.secondary' }}
          >
            <IconButton
              color="inherit"
              size="small"
              href="https://github.com/mui"
              aria-label="GitHub"
              sx={{ alignSelf: 'center' }}
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://x.com/MaterialUI"
              aria-label="X"
              sx={{ alignSelf: 'center' }}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://www.linkedin.com/company/mui/"
              aria-label="LinkedIn"
              sx={{ alignSelf: 'center' }}
            >
              <LinkedInIcon />
            </IconButton>
          </Stack> */}
        </Box>
      </Container>
    </React.Fragment>
  );
}
